export function createCustomEvents<T>({ eventName, data }: { eventName: string; data?: T }) {
    const event =
        data !== undefined
            ? new CustomEvent(eventName, { detail: data })
            : new Event(eventName);
    document.dispatchEvent(event);
}
